export default "__VITE_ASSET__b6daaa19__"